import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { IFileDownloader } from "src/uicomponents/components/fileSelector/fileSelector-viewModel";
import { Enum, IEnumTranslator, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { ChequePaymentTimeReportView } from "./chequePaymentTimeReport-view"

export class ChequePaymentTimeReportViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'گزارش سررسید چک'
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.rows = ObservableArray.create<row>();
        this.transactionTypeEnumProvider = new TransactionTypeEnumProvider();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.from = moment.utc().local().hours(0).minutes(0).second(0).utc();
        this.until = moment.utc().add(1,"days").local().hours(0).minutes(0).second(0).utc();
    }
    GetDefaultView(): View <ViewModel> {
        return new ChequePaymentTimeReportView();
    }
    public getTypeId(): string {
        return "VM-7CBA08A1-ED86-42EE-8529-66B19784D4BD"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set transactionTypeEnumProvider(v: TransactionTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTypeEnumProvider { return this._transactionTypeEnumProvider;} private _transactionTypeEnumProvider: TransactionTypeEnumProvider;
    public set rows(v: ObservableArray<row>) { this._rows = v; } public get rows(): ObservableArray<row> { return this._rows;} private _rows: ObservableArray<row>;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    
    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ArapServices/GetAllChequePayableAndReceivables',{
                FurtherQueryInfo:filteringInformation,
                From : this.from,
                Until : this.until
            });
            let downloader = new Downloader();
            this.rows.update(...result.PayableReceivables.map((x,i)=>{
                let r = new row(this);
                r.index = i+1;
                r.id = x.Id;
                r.amount = x.Amount;
                r.arapNo = x.ArapNo;
                r.accountingCode = x.AccountingCode;
                r.comment = x.Comment;
                r.time = moment.utc(x.Time);
                r.type = x.Type;
                r.requestAttachments.update(...x.Attachments.map(q=>{
                    let a = new attachment(r);
                    a.id = q.Id;
                    a.name = q.Name;
                    a.downloader = downloader;
                    return a;
                }))
                r.hasAttachments = r.requestAttachments.length>0;
                r.chequeNo = x.ChequeNo;
                r.bankName = x.ChequeBankName;
                r.reason = x.ChequeReason;
                r.isForGuarantee = x.ChequeIsForGuarantee;
                r.chequeTime = moment.utc(x.ChequeDate);
    
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
}
class Downloader implements IFileDownloader{
    async download(fileId: string, filename: string): Promise<{ name: string; content: string; }> {
        let result = await ServerConnection.callServer('/Complex/ArapServices/GetTransactionAttachmentFileContent',{
            FileId : fileId
        });
        return {
            name : filename,
            content : result.FileContent
        };
    }

} 
export class row extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.showDetail = false;
        this.requestAttachments = ObservableArray.create<attachment>();
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set accountingCode(v: string) { this._accountingCode = v; } public get accountingCode(): string { return this._accountingCode;} private _accountingCode: string;
    public set arapNo(v: string) { this._arapNo = v; } public get arapNo(): string { return this._arapNo;} private _arapNo: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type;} private _type: number;
    public set showDetail(v: boolean) { this._showDetail = v; } public get showDetail(): boolean { return this._showDetail;} private _showDetail: boolean;
    public set requestAttachments(v: ObservableArray<attachment>) { this._requestAttachments = v; } public get requestAttachments(): ObservableArray<attachment> { return this._requestAttachments;} private _requestAttachments: ObservableArray<attachment>;
    public set hasAttachments(v: boolean) { this._hasAttachments = v; } public get hasAttachments(): boolean { return this._hasAttachments;} private _hasAttachments: boolean;
    
    public set chequeNo(v: string) { this._chequeNo = v; } public get chequeNo(): string { return this._chequeNo;} private _chequeNo: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName;} private _bankName: string;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set isForGuarantee(v: boolean) { this._isForGuarantee = v; } public get isForGuarantee(): boolean { return this._isForGuarantee;} private _isForGuarantee: boolean;
    public set chequeTime(v: moment.Moment) { this._chequeTime = v; } public get chequeTime(): moment.Moment { return this._chequeTime;} private _chequeTime: moment.Moment;
    
    toggleDetail(){
        this.showDetail = !this.showDetail;
    }
}
export class attachment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set downloader(v: IFileDownloader) { this._downloader = v; } public get downloader(): IFileDownloader { return this._downloader;} private _downloader: IFileDownloader;
    
}

export class TransactionTypeEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2];        
    }
    GetString(value: any) {
        return new TranslatorConverter().payableReceivableConverter(value);
    }
}

